export default function HorizontalStriped({
  baseColor = '#ffffff',
  stripesColor = '#ffffff',
  ...props
}) {
  return (
    <svg
      width="127.24603px"
      height="127.24603px"
      viewBox="0 -7.72 127.24603 127.24603"
      y="0px"
      x="0px"
      {...props}>
      <g>
        <path
          fill={baseColor}
          d="m32 109c-1.4 0-2.5-1.1-2.5-2.5v-62.6l-7 5.9c-.1.1-.2.1-.2.2-1 .6-2.1 1-3.2 1-2 0-3.8-1-4.9-2.6l-10.7-16.1c-1.8-2.7-1-6.3 1.7-8.1l29.7-20.7c.2-.1.4-.3.7-.3.1 0 2.8-.9 6.6-1h3.1c.7 0 1.4.3 1.8.8.5.5.7 1.2.6 1.9 0 .1 0 .3-.1.4.2 7.5 8.1 14.5 16.5 14.5s16.3-7 16.5-14.5c0-.1 0-.3-.1-.4-.1-.7.2-1.4.6-1.9s1.1-.8 1.8-.8h6.1c2.4 0 4.3 1.1 4.5 1.2.1 0 .1.1.2.1l28.7 20.7c2.6 1.7 3.4 5.4 1.6 8.1l-10.7 15.2c-1 1.6-2.9 2.6-4.9 2.6-1.2 0-2.3-.3-3.2-1-.1 0-.1-.1-0.2-.2l-6.4-5.3-.2 62.9c0 1.4-1.1 2.5-2.5 2.5h-63.9z"
        />
        <path
          fill={stripesColor}
          d="m42.2 2.5c-3.8.1-6.5 1-6.6 1-.3 0-.5.20-.7.30l-22.3 15.5h46.6c-6.4-2-11.5-7.7-11.6-13.7.1-.10.1-.30.1-.40.1-.70-.1-1.4-.6-1.9-.4-.50-1.1-.80-1.8-.80h-3.1zm40.7 0c-.7 0-1.4.30-1.8.80s-.7 1.2-.6 1.9c.1.10.1.30.1.40-.2 6-5.3 11.7-11.6 13.7h46l-21.3-15.5c-.1 0-.1-.10-.2-.10-.2-.10-2.1-1.2-4.5-1.2h-6.1zm-78.6 31.3l9.63 14.5h10.7l4.9-4.1v4.1h69.1v-4.4l5.4 4.4h9v-.5l10-14h-119zm25.2 29v14.5h69v-14.5h-69zm0 29v15.2c0 1 1.1 2 2.5 2h63.9c1.4 0 2.5-1 2.5-2v-15.2h-68.9z"
        />
        <path d="m89.1 5c1.8 0 3.1.9 3.1.9l28.7 20.6c1.6 1 2 3.1.9 4.7l-10.7 15.1c-0.6 1-1.7 1.5-2.8 1.5-.6 0-1.3-.2-1.9-.6l-10.5-8.6-.2 68.2h-63.7v-68l-11.2 9.4c-.6.4-1.2.6-1.9.6-1.1 0-2.2-.5-2.8-1.5l-10.6-16.1c-1-1.6-.6-3.6.9-4.7l29.7-20.7s2.4-.8 5.8-.9h3.1v.2.2c0 9 9.1 17.3 19 17.3s19-8.3 19-17.3v-.2-.2h5.9.2c-.1.1 0 .1 0 .1m0-5s-.1 0 0 0h-.2-5.9c-1.4 0-2.7.6-3.7 1.6-.9 1-1.4 2.4-1.3 3.8v.4c-.3 6.1-7.1 11.9-14 11.9s-13.7-5.8-14-11.9v-.4c.1-1.4-.3-2.8-1.3-3.8-.9-1-2.3-1.6-3.7-1.6h-3.1-.1c-4 .1-6.9 1-7.3 1.1-.5.2-.9.4-1.3.7l-29.5 20.6c-3.8 2.6-4.8 7.7-2.3 11.6l10.7 16.1c1.6 2.3 4.2 3.7 7 3.7 1.6 0 3.2-.5 4.6-1.4.2-.1.3-.2.5-.3l2.9-2.5v57.2c0 2.8 2.2 5 5 5h63.8c2.8 0 5-2.2 5-5l.1-57.7 2.3 1.9c.1.1.3.2.4.3 1.4.9 3 1.4 4.6 1.4 2.8 0 5.4-1.4 6.9-3.7l10.6-15 .1-.1c2.5-3.8 1.5-9-2.3-11.5l-28-20.9c-.1-.1-.2-.1-.3-.2-.3-.2-2.6-1.5-5.6-1.5z" />
      </g>
    </svg>
  );
}
